export default "__VITE_ASSET__BlXqOhzS__"